module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/patientprofile-view/patientprofile-view.component.html
// module id = ./src/app/Pages/tasks/patientprofile-view/patientprofile-view.component.html
// module chunks = main